import { Search } from "/react4xp/shared/search/search";

export default (props) => <Search {...props} />
